import { gql } from "@apollo/client";

export const CREATE_PO = gql`
  mutation CreatePO($customer_id: Int!, $start_date: String!, $end_date: String!, $email: String!) {
    createPO(customer_id: $customer_id, start_date: $start_date, end_date: $end_date, email: $email) {
      _id
      po_number
      po_date
      customer_id
      balance_due
      total
      email
    }
  }
`;

export const GENERATE_PO_PDF = gql`
  mutation PurchaseOrderPDF($_id: String!) {
    purchaseOrderPDF(_id: $_id)
  }
`;
